export default __webpack_public_path__ + "static/media/starFav2.92d756da.svg";